import React from 'react';
export function TablePageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15625">
      <span className="sr-only" data-id="element-15626">Loading table…</span>
      {/* Header with button */}
      <div className="flex justify-between items-center" data-id="element-15627">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-15628" />
        <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-15629" />
      </div>
      {/* Stats cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-15630">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-15631">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15632" />
            <div className="h-8 w-32 bg-gray-200 rounded mb-2" data-id="element-15633" />
            <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15634" />
          </div>)}
      </div>
      {/* Table */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-15635">
        {/* Table header */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-15636">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15637" />
          <div className="h-10 w-64 bg-gray-200 rounded-md" data-id="element-15638" />
        </div>
        {/* Table content */}
        <div className="overflow-x-auto" data-id="element-15639">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-15640">
            <thead data-id="element-15641">
              <tr data-id="element-15642">
                {[1, 2, 3, 4, 5].map(i => <th key={i} className="px-4 py-3" data-id="element-15643">
                    <div className="h-3 w-20 bg-gray-200 rounded" data-id="element-15644" />
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-15645">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(i => <tr key={i} data-id="element-15646">
                  {[1, 2, 3, 4, 5].map(j => <td key={j} className="px-4 py-4" data-id="element-15647">
                      <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15648" />
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="p-4 border-t border-gray-200 flex justify-between items-center" data-id="element-15649">
          <div className="h-4 w-32 bg-gray-200 rounded" data-id="element-15650" />
          <div className="flex gap-2" data-id="element-15651">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-8 bg-gray-200 rounded" data-id="element-15652" />)}
          </div>
        </div>
      </div>
    </div>;
}